class FoldController {
  constructor(block) {
    // A new element to wrap the block
    this.wrapper = document.createElement('div');
    // a secondary wrapper to hide the overflow
    this.overflow = document.createElement('div');
    // The block itself
    this.block = block;
    // the offset of the block
    this.offset = 0;
    // The enabled state of the animation
    this.enabled = false;

    this.debug = document.createElement('div');
    this.debug.style.position = 'absolute';
    this.debug.style.zIndex = 999999;

    // Add a class to the wrapper
    this.wrapper.classList.add('fold-controller');
    // Add a class to the overflow
    this.overflow.classList.add('fold-controller__ovh');

    // Add the wrapper before the block
    this.block.parentNode.insertBefore(this.wrapper, this.block);

    // Append the ovh into the wrapper
    this.wrapper.appendChild(this.overflow);
    // Append the block into the ovh
    this.overflow.appendChild(this.block);

    // document.body.appendChild(this.debug);

    // An object to keep track of the block's visible state
    this.cache = {
      scrollY: 0,
    };

    // An intersection observer to see if the block is visible
    this.IntersectionObserver = new IntersectionObserver((entries) => {
      // if (window.innerWidth < 1024) return this.enabled = false;
      // If the block is visible, enable the animation
      this.enabled = entries[0].isIntersecting;
    });

    // Observe the block wrapper
    this.IntersectionObserver.observe(this.wrapper);

    // This resize observer will be used to detect when the block is resized
    this.ResizeObserver = new ResizeObserver(() => this.resize());

    this.ResizeObserver.observe(this.block);

    // Resize
    this.resize();

    // animate
    this.animate();
  }

  resize() {
    let el = this.block;

    // Set the height of the block
    this.height = this.block.clientHeight;

    // Set the offset to 0
    this.offset = 0;

    while (el) {
      this.offset += el.offsetTop;
      el = el.offsetParent;
    }

    this.debug.style.top = this.offset + this.height + 'px';
    this.debug.innerHTML = this.offset + this.height;
  }

  animate() {
    window.requestAnimationFrame(() => {
      if (this.enabled === false) return this.animate();
      if (this.cache.scrollY === window.scrollY) return this.animate();

      this.cache.scrollY = window.scrollY;

      let offset = window.scrollY - this.offset;
      let height = (window.innerHeight * .5) - this.height;
      let magnitude = (window.innerWidth < 1024) ? .3 : .8;
      // if (window.innerWidth < 1024) return this.enabled = false;

      if (offset < 0) offset = 0;
      if (height > 0) height = 0;

      // translate has a minimum of 0
      let translation = (offset + height) * magnitude;
      // let scale = 1;
      // let blur = 0;
      // let brightness = 1

      if (translation < 0) translation = 0;

      translation = Math.round(translation);

      // /* scale = 1 + (translation / (50 * window.innerHeight));
      // blur = (translation / 100); */
      // brightness = (1 - (translation / 1000));

      // // if (scale < 1) scale = 1;
      // // if (blur < 0) blur = 0;
      // if (brightness < 0) brightness = 0;

      // // scale = Math.round(scale * 1000) / 1000;
      // // blur = Math.round(blur * 10) / 10;
      // brightness = Math.round(brightness * 100) / 100;


      this.block.style.transform = `translateY(${translation}px)`;
      // this.block.style.filter = `brightness(${brightness})`;

      this.animate();
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const folds = [...document.querySelectorAll('.js-blocks-fold')];


  folds.forEach((block, index) => {
    // We dont need to fold the last section
    if (index === folds.length - 1) return;
    // Create a new fold
    const Fold = new FoldController(block);
  });
});
